import { render, staticRenderFns } from "./DatatableExports.vue?vue&type=template&id=3496d954&"
import script from "./DatatableExports.vue?vue&type=script&lang=js&"
export * from "./DatatableExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports